module.exports = __webpack_public_path__ + "static/media/[Audio]2010-07-18-8.4e59b171.md";